/*
 * @Author: zhao - 🍉
 * @Date: 2022-02-14 20:55:00
 * @LastEditTime: 2022-02-14 23:09:45
 * @LastEditors: zhao - 🍉
 * @Description: 收房合同房租周期 - 编辑
 * @FilePath: /zhzj-admin/src/page/RentCycle/update.jsx
 */


import {Modal, Input, message, Select, Upload, Icon, DatePicker, Form} from 'antd';
import React, {useState, useRef, forwardRef} from 'react'
import { CustomCol, CustomRow } from '../../components/Custom';
import DetailTitle from '../../components/DetailTitle';
import ModalScrollContainer from '../../components/ModalScrollContainer';
import { fetchRentCycleAdd, fetchRentCycleGet, fetchRentCycleUpdate } from '../../services/rentCycle';
import FileUpload_JR from "../../components/FileUpload_JR";
import moment from "moment";
import {fetchDeviceAdd, fetchDeviceGet, fetchDeviceUpdate} from "../../services/device";
const RentCycleUpdate = (props) => {
    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [detailData, setDetailData] = useState({});
    const [id, setId] = useState(null);
    const [merchantId, setMerchantId] = useState(null);
    let monitor = useRef(null)
    const { getFieldDecorator,setFieldsValue } = props.form

    const open = (merchantId,_id) => {
        setMerchantId(merchantId)
        setVisible(true)
        setId(_id || null)
        if (_id) {
            postRentCycleGet({id: _id})
        } else {
            setDetailData({})
        }
        return new Promise((resolve, reject) => {
            monitor.current = resolve
        })
    }
    const close = () => {
        setVisible(false)
    }



    const postRentCycleGet = (data) => {
        setLoading(true)
        fetchDeviceGet(data).then(res => {
            setDetailData(res || {})
            if(res.imgUrl){
                this.fileUploadRef_Device.set(res.imgUrl)
            }
        }).finally(() => {
            setLoading(false)
        })
    }
    const postSubmit = (data) => {
        const post = id ? fetchDeviceUpdate : fetchDeviceAdd
        data.id = id || undefined
        data.merchantId = merchantId
        setLoading(true)
        return post(data).then(res => {
            message.success('保存成功')
        }).finally(() => {
            setLoading(false)
        })
    }
    const handleSetFormData = (data = {}) => {
        setDetailData({...detailData, ...data})
    }
    const handleSubmit = () => {

        if (!detailData.repairStartDate) return message.warning('请输入开始日期')
        if (!detailData.repairEndDate) return message.warning('请输入结束日期')
        if (!detailData.deviceCategory) return message.warning('请输入设备品类')
        if (!detailData.deviceModel) return message.warning('请输入设备型号')
        if (!detailData.rent) return message.warning('请输入设备租金')
        detailData.url = this.fileUploadRef_Device.get().map(e => e.url)

        if(detailData.url==null){
            detailData.imgUrl =""
        }else{
            detailData.imgUrl = detailData.url[0];
        }

        postSubmit(detailData).then(() => {
            close()
            monitor.current()
        })
    }



    props.getRef && props.getRef({ open });

    return (
        <Modal
            title="设备维护"
            width={750}
            visible={visible}
            onOk={handleSubmit}
            confirmLoading={loading}
            onCancel={close}
        >
            <ModalScrollContainer style={{ paddingTop: 0 }} loading={loading}>

                <div className="custom" >
                    <CustomRow divider>
                        <CustomCol label="设备品类">
                            <Input value={detailData.deviceCategory} onChange={(e) => handleSetFormData({deviceCategory: e.target.value})} />
                        </CustomCol>
                        <CustomCol label="设备型号">
                            <Input value={detailData.deviceModel} onChange={(e) => handleSetFormData({deviceModel: e.target.value})} />
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider>
                        <CustomCol label="保修开始日期">
                            {getFieldDecorator('repairStartDate', {
                                rules: [{
                                    required: true, message: '请选择',
                                }],
                                initialValue: detailData.repairStartDate ? moment(detailData.repairStartDate) :null
                            })(
                                <DatePicker
                                    placeholder={'请选择'}
                                    allowClear={false}
                                    onChange={(date) => {
                                        handleSetFormData({repairStartDate: date});
                                        // let { leaseTermTime: { end } } = this.state;
                                        // this.setState({ leaseTermTime: { start: date, end } });
                                    }}
                                />
                            )}
                        </CustomCol>
                        <CustomCol label="保修结束日期">
                            {getFieldDecorator('repairEndDate', {
                                rules: [{
                                    required: true, message: '请输入',
                                }],
                                initialValue: detailData.repairEndDate ? moment(detailData.repairEndDate) : null
                            })(
                                <DatePicker
                                    placeholder={'请选择'}
                                    allowClear={false}
                                    onChange={(date) => {
                                        handleSetFormData({repairEndDate: date});
                                        // let { leaseTermTime: { start } } = this.state;
                                        // this.setState({ leaseTermTime: { start, end: date } });
                                    }}
                                />
                            )}
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider>
                        <CustomCol label="租金">
                            <Input value={detailData.rent} type="number" onChange={(e) => handleSetFormData({rent: e.target.value})} />
                        </CustomCol>
                    </CustomRow>
                    <DetailTitle title="设备图片" />
                    <FileUpload_JR ref={(ref) => this.fileUploadRef_Device = ref}   />
                </div>
            </ModalScrollContainer>
        </Modal>
    )
}

export default Form.create()(forwardRef(RentCycleUpdate))



// WEBPACK FOOTER //
// ./src/page/Device/update.jsx